// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { Avatar, Box, Skeleton, Stack, Typography } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';

// assets
import StorefrontTwoToneIcon from '@mui/icons-material/StorefrontTwoTone';
import { useEffect, useState } from 'react';
import axios from 'axios';
import ApiLink from 'API';
import { useNavigate } from 'react-router';
import NumberFormat from 'react-number-format';

// Decorative gradient blob — orange/warning accent
const CardWrapper = styled(MainCard)(({ theme }) => ({
    overflow: 'hidden',
    position: 'relative',
    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
    '&:hover': {
        transform: 'translateY(-3px)',
        boxShadow: '0 12px 28px -10px rgba(245, 114, 36, 0.25)'
    },
    '&:after': {
        content: '""',
        position: 'absolute',
        width: 260,
        height: 260,
        background: `linear-gradient(210.04deg, ${theme.palette.warning.dark} -50.94%, rgba(245, 114, 36, 0) 83.49%)`,
        borderRadius: '50%',
        top: -40,
        right: -200,
        opacity: 0.75,
        pointerEvents: 'none'
    },
    '&:before': {
        content: '""',
        position: 'absolute',
        width: 180,
        height: 180,
        background: `linear-gradient(140.9deg, ${theme.palette.warning.dark} -14.02%, rgba(245, 114, 36, 0) 70.50%)`,
        borderRadius: '50%',
        top: -130,
        right: -110,
        opacity: 0.6,
        pointerEvents: 'none'
    }
}));

const TotalCardSummary = () => {
    const theme = useTheme();
    const [isLoading, setisLoading] = useState(true);
    const navigate = useNavigate();
    const [Data, setData] = useState([]);

    useEffect(() => {
        let isMounted = true;
        const LoadData = async () => {
            try {
                setisLoading(true);
                const response = await axios.get(ApiLink + '/api/dashboard/sale/summary/price', {
                    withCredentials: true,
                    headers: { token: localStorage.getItem('token') }
                });
                if (isMounted) {
                    if (response.status === 200) {
                        setData(response.data.data || []);
                        setisLoading(false);
                    } else if (response.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                }
            } catch (error) {
                if (isMounted) {
                    setisLoading(false);
                    if (error?.response?.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                    console.log(error);
                }
            }
        };
        LoadData();
        return () => { isMounted = false; };
    }, []);

    return (
        <CardWrapper border={false} content={false}>
            <Box sx={{ p: 2.5, position: 'relative', zIndex: 1 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
                    <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                            variant="caption"
                            sx={{
                                color: theme.palette.grey[600],
                                textTransform: 'uppercase',
                                letterSpacing: '0.08em',
                                fontWeight: 700,
                                fontSize: '0.7rem'
                            }}
                        >
                            Total Stock Value
                        </Typography>

                        {isLoading ? (
                            <Skeleton variant="text" width="70%" height={42} />
                        ) : (
                            <Typography
                                variant="h3"
                                sx={{
                                    color: theme.palette.warning.dark,
                                    fontWeight: 800,
                                    fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.75rem' },
                                    letterSpacing: '-0.01em',
                                    overflowWrap: 'break-word'
                                }}
                            >
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={Data[0]?.summary || 0}
                                    prefix="₭"
                                    decimalSeparator="."
                                    displayType="text"
                                    thousandSeparator={true}
                                    allowNegative={true}
                                />
                            </Typography>
                        )}

                        <Typography variant="caption" sx={{ color: theme.palette.grey[500], mt: 0.5 }}>
                            ມູນຄ່າສິນຄ້າຄົງຄັງທັງໝົດ
                        </Typography>
                    </Stack>

                    <Avatar
                        variant="rounded"
                        sx={{
                            width: 52,
                            height: 52,
                            borderRadius: 2.5,
                            backgroundColor: theme.palette.warning.light,
                            color: theme.palette.warning.dark,
                            boxShadow: '0 6px 16px -6px rgba(245, 114, 36, 0.45)'
                        }}
                    >
                        <StorefrontTwoToneIcon fontSize="medium" />
                    </Avatar>
                </Stack>
            </Box>
        </CardWrapper>
    );
};

export default TotalCardSummary;
